import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import MailIcon from "@material-ui/icons/Mail";
import { Trad } from "../../components/";
import * as Glob from "../../Globale";
import { _AdminMenu, _UserMenu } from "../layout";

const useStyles = makeStyles(theme => ({
    toolbar: {
        flexGrow: 1,
        display: "flex",
        justifyContent: "flex-end"
    }
}));

export const _UserProfile = () => {
    const classes = useStyles();
    const session = Glob.GetSessione();

    return (
        <Box className={classes.toolbar}>
            {session && <_UserMenu />}
            {Glob.AzioneAbilitata("Admin", Glob.Lettura) && <_AdminMenu />}
        </Box>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/UserProfile.tsx